import React from 'react';

// Translations
import translate from '../Translate.js';

// Components
import Password from '../Common/Password';

class ResetPassword extends React.Component {
  constructor() {
    super();

    // Bind this to functions
    this.checkPassword = this.checkPassword.bind(this);
    this.resetPassword = this.resetPassword.bind(this);
  }

  checkPassword(e) {
    e.preventDefault();

    if(this.password.value !== this.confirm.value) {
      this.confirm.setCustomValidity('Passwords do not match.');
    } else {
      this.confirm.setCustomValidity('');
    }

    this.props.checkValidity(e, this.resetPassword);
  }

  resetPassword() {
    const { translation } = this.props;
    console.log(this.props);
    const { SessionStore, SettingsStore } = this.props.store;

    const search = new URLSearchParams(this.props.routing.location.search);

    const account = search.get('account');
    const key = search.get('key');
    const user = search.get('user');
    const username = search.get('username');

    const data = {
      newPassword: this.password.value,
      confirmPassword: this.confirm.value
    }

    if(key) {
      // If a change key was in the url, use it
      data.passwordChangeKey = key
    } else {
      // Otherwise require the current password
      data.currentPassword = this.current.value;
    }

    let callback = null;

    if(username) {
      // If a username was provided in the url,
      // automatically log in after changing
      const reroute = () => {
        this.props.routing.history.push('/');
      }

      callback = () => {
        SessionStore.login(username, this.password.value, reroute);
      }
    } else {
      // Otherwise, redirect to the dashboard
      callback = () => {
        this.props.routing.history.push('/');
        SessionStore.showToaster(translation.success, 'success');
      }
    }

    SettingsStore.updatePassword(data, callback, account, user);
  }

  render() {
    const { translation } = this.props;
    const search = new URLSearchParams(this.props.routing.location.search);
    const key = search.get('key');

    return(
      <div className="pane__content">
        {!this.props.standalone &&
          <h1 className="pane__title">
            {translation.heading}
          </h1>
        }



        <form
          onSubmit={(e) => this.checkPassword(e)}
          noValidate
        >
          <fieldset>
            <ul className="fields">
              {!key &&
                <li>
                  <label
                    className="meta"
                    htmlFor="reset-current"
                  >
                    {translation.current_password}
                  </label>

                  <input
                    type="password"
                    id="reset-current"
                    placeholder={translation.current_password}
                    required
                    aria-required="true"
                    ref={(input) => this.current = input}
                  />
                </li>
              }
              <li>
                <label
                  className="meta"
                  htmlFor="reset-password"
                >
                  {translation.password}
                </label>

                <Password
                  id="reset-password"
                  placeholder={translation.password}
                  changeFunction={this.handleInput}
                  parent={this}
                  name="password"
                  {...this.props}
                />
              </li>
              <li>
                <label
                  className="meta"
                  htmlFor="reset-confirm"
                >
                  {translation.confirm_password}
                </label>

                <input
                  type="password"
                  id="reset-confirm"
                  placeholder={translation.confirm_password}
                  required
                  aria-required="true"
                  ref={(input) => this.confirm = input}
                />
              </li>
            </ul>
          </fieldset>

          <button
            className="btn--link"
            type="button"
          >
            {translation.cancel}
          </button>

          <button
            className="btn"
            type="submit"
          >
            {translation.reset}
          </button>
        </form>
      </div>
    )
  }
}

export default translate('ResetPassword')(ResetPassword);



// WEBPACK FOOTER //
// ./src/app/components/Account/ResetPassword.js